import React from "react";
import "./Who.css";
import photo from "./photo.jpg";

export default () => {
  return (
    <div className="page who">
      <header className="page-header">
        <h2>Who We Are</h2>
      </header>
      <article className="page-content who-content">
        <figure>
          <img src={photo} alt="Amanda" />
        </figure>
        <section>
          <p>
            Amanda Gossett brings over 10 years of real estate experience to
            Closing Bot - both as a licensed agent and operations manager
            working with top producing teams.
          </p>

          <p>
            She has greatly enjoyed all aspects of the real estate business, but
            has found her true calling in supporting other agents become more
            productive and successful through listing and contract management.
            She firmly believes in smart, efficient systems and with her
            attention to detail, she is able to deliver top notch service to
            agents and their clients.
          </p>

          <p>
            Amanda lives in Decatur with her husband Jarrett, children Eleanor
            and Henry and their cat Marty.
          </p>
        </section>
      </article>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Who.js